import { typedAttributeIds } from '../constants';

export function isTypedAttribute(attributeID: number) {
  return typedAttributeIds.includes(attributeID);
}
